import { render, staticRenderFns } from "./PlatformPage.vue?vue&type=template&id=bbb96ddc&scoped=true"
import script from "./PlatformPage.vue?vue&type=script&lang=js"
export * from "./PlatformPage.vue?vue&type=script&lang=js"
import style0 from "./PlatformPage.vue?vue&type=style&index=0&id=bbb96ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb96ddc",
  null
  
)

export default component.exports